// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__FxQfo","footer":"Layout_footer__eJwb-","footer_line":"Layout_footer_line__tg2iX","icons":"Layout_icons__2DPhA"};